export const status = {
  ALL: 'ALL',
  AVAILABLE: 'AVAILABLE',
  REPAIRING: 'REPAIRING',
  OUT_OF_SERVICE: 'OUT_OF_SERVICE',
}

export const statusText = {
  ALL: 'ทั้งหมด',
  AVAILABLE: 'พร้อมใช้งาน',
  REPAIRING: 'กำลังซ่อมบำรุง',
  OUT_OF_SERVICE: 'ไม่พร้อมใช้งาน',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const truckType = [
  { value: 'PADOONGRICH', text: 'ผดุงฤทธิ์' },
  { value: 'JOINTCAR', text: 'รถร่วมในเครือ' },
  { value: 'OUTJOINTCAR', text: 'รถร่วมนอก' },
]
